import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { 
  GraduationCap, Search, Loader2, ArrowLeft, Users, Download
} from 'lucide-react';
import { teacherPanelAPI } from '../../services/api';
import * as XLSX from 'xlsx';

const TeacherGroupStudents = () => {
  const { groupId } = useParams();
  const [group, setGroup] = useState(null);
  const [students, setStudents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    fetchGroupStudents();
  }, [groupId]);

  const fetchGroupStudents = async () => {
    try {
      const response = await teacherPanelAPI.getGroupStudents(groupId);
      setGroup(response.data.group);
      setStudents(response.data.students || []);
    } catch (error) {
      console.error('Talabalarni yuklashda xato:', error);
    } finally {
      setLoading(false);
    }
  };

  const exportToExcel = () => {
    const data = filteredStudents.map((student, index) => ({
      '№': index + 1,
      'Familiya': student.user.last_name || '',
      'Ism': student.user.first_name || '',
      'Sharifi': student.user.middle_name || '',
      'Talaba ID': student.student_id || '',
      'Telefon': student.user.phone || ''
    }));
    
    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, group?.name || 'Talabalar');
    
    ws['!cols'] = [
      { wch: 5 },
      { wch: 15 },
      { wch: 15 },
      { wch: 15 },
      { wch: 12 },
      { wch: 15 }
    ];
    
    XLSX.writeFile(wb, `${group?.name || 'talabalar'}_${new Date().toISOString().split('T')[0]}.xlsx`);
  };

  const filteredStudents = students.filter(student => {
    const fullName = `${student.user.last_name} ${student.user.first_name}`.toLowerCase();
    return fullName.includes(searchTerm.toLowerCase()) ||
           student.student_id?.toLowerCase().includes(searchTerm.toLowerCase());
  });

  if (loading) {
    return (
      <div className="loading-container">
        <Loader2 className="spinner" size={40} />
        <p>Yuklanmoqda...</p>
      </div>
    );
  }

  return (
    <div className="page-container">
      <header className="page-header">
        <div className="page-title">
          <Link to="/teacher/groups" className="back-link">
            <ArrowLeft size={20} />
            Guruhlar
          </Link>
          <h1><Users size={28} /> {group?.name}</h1>
          <p>{group?.course}-kurs • {students.length} talaba</p>
        </div>
        <div className="header-actions">
          <button className="btn btn-secondary" onClick={exportToExcel}>
            <Download size={20} /> Excel
          </button>
        </div>
      </header>

      {/* Search */}
      <div className="search-bar">
        <Search size={20} />
        <input 
          type="text" 
          placeholder="Talabani qidirish..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>

      {/* Students Table */}
      <div className="table-container">
        <table className="data-table">
          <thead>
            <tr>
              <th>№</th>
              <th>F.I.Sh</th>
              <th>Talaba ID</th>
              <th>Telefon</th>
            </tr>
          </thead>
          <tbody>
            {filteredStudents.map((student, index) => (
              <tr key={student.id}>
                <td>{index + 1}</td>
                <td>
                  <strong>{student.user.full_name}</strong>
                </td>
                <td>
                  <span className="badge badge-secondary">{student.student_id}</span>
                </td>
                <td>{student.user.phone || '-'}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {filteredStudents.length === 0 && (
          <div className="empty-state">
            <GraduationCap size={48} />
            <p>Talabalar topilmadi</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default TeacherGroupStudents;
